export default __webpack_public_path__ + "static/media/TCWirelessNoSignal.731c5885.svg";